module.exports = __webpack_public_path__ + "img/insta.0f102f24.svg";